import axios from 'axios';

export default (data) => axios.post(`/v1/password/reset`, data);
